import { http } from "../config.api.js"
// import api  from "@/api/api.js"

// 施工项目考评相关 API_ProjectCheck

export const materialPostRecord = (pageInfo, params) => { return http.get("/projectMaterialsPost/materialPostRecord/" + pageInfo, { urlParams: params }).then(res => res.data); };

// 季考评
export const listQuarterRegist = (pageInfo, params) => { return http.get("/safetyProjectQuarterEval/unitInfos/" + pageInfo, { urlParams: params }).then(res => res.data); };

export const getQuarterDetail = params => { return http.get("/safetyProjectQuarterEval", { urlParams: params }).then(res => res.data); };

export const updateQuarter = params => { return http.post("/safetyProjectQuarterEval/update", params).then(res => res.data); };

export const sealUpdateQuarter = params => { return http.post("/safetyProjectQuarterEval/sealAndSubmit", params).then(res => res.data); };

// 月考评
export const listMonthRegist = (pageInfo, params) => { return http.get("/safetyProjectMonthEval/safetyProjectMonthEvals/" + pageInfo, { urlParams: params }).then(res => res.data); };

export const listMonthQuery = (pageInfo, params) => { return http.get("/safetyProjectMonthEval/unitInfos/" + pageInfo, { urlParams: params }).then(res => res.data); };

export const listMonthSign = (pageInfo, params) => { return http.get("/safetyProjectMonthEval/safetyProjectMonthEvalsByStatus/" + pageInfo, { urlParams: params }).then(res => res.data); };

// 月考评详情-弃用
export const getMonthDetail = params => { return http.get("/safetyProjectMonthEval", { urlParams: params }).then(res => res.data); };

// 月考评详情-新
export const getMonthOthDetail = params => { return http.get("/safetyProjectMonthEval/detail", { urlParams: params }).then(res => res.data); };

export const withdrawMonth = params => { return http.post("/safetyProjectMonthEval/pmUndoSubmit", params).then(res => res.data); };

export const updateMonth = params => { return http.post("/safetyProjectMonthEval/update", params).then(res => res.data); };

// 竣工考评
export const listFinishedRegist = (pageInfo, params) => { return http.get("/safetyProjectFinishedEvalsp/safetyProjectFinishedEvalsps/" + pageInfo, { urlParams: params }).then(res => res.data); };

export const listFinishedPublicity = (pageInfo, params) => { return http.get("/safetyProjectFinishedEvalsp/selectProjectResultPublicity/" + pageInfo, { urlParams: params }).then(res => res.data); };

export const homeListFinishedPublicity = (pageInfo, params) => { return http.get("/homepage/projectResultPublicity/" + pageInfo, { urlParams: params }).then(res => res.data); };

export const listFinishedInform = (pageInfo, params) => { return http.get("/safetyProjectFinishedEvalsp/selectProjectResultInform/" + pageInfo, { urlParams: params }).then(res => res.data); };

export const homeListFinishedInform = (pageInfo, params) => { return http.get("/homepage/projectResultInform/" + pageInfo, { urlParams: params }).then(res => res.data); };

export const listFinishedSign = (pageInfo, params) => { return http.get("/safetyProjectFinishedEvalsp/safetyProjectFinishedEvalsByStatus/" + pageInfo, { urlParams: params }).then(res => res.data); };

export const getFinishedDetail = params => { return http.get("/safetyProjectFinishedEvalsp", { urlParams: params }).then(res => res.data); };

export const updateFinished = params => { return http.post("/safetyProjectFinishedEvalsp/update", params).then(res => res.data); };

export const submitByPm = params => { return http.post("/safetyProjectFinishedEvalsp/submitByPm", params).then(res => res.data); };

export const unitApplyDone = params => { return http.post("/safetyProjectFinishedEvalsp/submitByConstuction", params).then(res => res.data); };

export const backDone = params => { return http.post("/safetyProjectFinishedEvalsp/signBack", params).then(res => res.data); };

export const updateFinishedProjectName = params => { return http.post("/safetyProjectFinishedEvalsp/updateFinishedProjectName", params).then(res => res.data); };


// 撤销项目考评
export const listRevokeQuery = (pageInfo, params) => { return http.get("/safetyProjectFinishedEvalRevoke/safetyProjectFinishedEvalRevokes/" + pageInfo, { urlParams: params }).then(res => res.data); };

export const listRevokePublicity = (pageInfo, params) => { return http.get("/safetyProjectFinishedEvalRevoke/revokesResultPublicity/" + pageInfo, { urlParams: params }).then(res => res.data); };

export const getRevokeDetail = params => { return http.get("/safetyProjectFinishedEvalRevoke", { urlParams: params }).then(res => res.data); };

export const getmassDetail = params => { return http.get("/tproject", { urlParams: params }).then(res => res.data); };



// WEBPACK FOOTER //
// ./src/api/safetyCheck/api_cstProject.js